<template>
  <div class="relative flex flex-col items-center pt-10 pb-16 px-4 md:px-12 gap-8 bg-[#f4f6f1]">
    <div class="text-center">
      <h4 class="text-2xl font-semibold mb-2">
        {{ $t('products.cant_decide') }}
      </h4>
      <p class="text-xl">
        {{ $t('products.fill_your_cart_with_a_variety_pack') }}
      </p>
    </div>
    <div class="w-full max-w-(--breakpoint-lg)">
      <Splide
        :options="options"
        aria-label="Variety Packs"
        class="products-splide"
      >
        <SplideSlide
          v-for="pack in varietyPacks"
          :key="pack.id"
        >
          <VarietyPackCard
            :pack="pack"
            class="min-h-full"
          />
        </SplideSlide>
      </Splide>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { Splide, SplideSlide, type Options } from '@splidejs/vue-splide'
import { useVarietyPacksStore } from '@/stores'
import VarietyPackCard from '../variety-packs/variety-pack-card.vue'
const store = useVarietyPacksStore()
const { varietyPacks } = storeToRefs(store)

store.useVarietyPacks()

const options: Options = {
  type: 'loop',
  focus: 'center',
  pagination: true,
  gap: '1rem',
  perPage: 3,
  perMove: 1,
  breakpoints: {
    520: {
      perPage: 1
    }
  }
}
</script>
